import { dsokSectionDefinitions } from "./types/dsokSectionConfigs";

/**
 * Ordered list of section definitions for DSOK Customer Detail.
 * Each section has: id, labelKey, descriptionKey, icon, getPermission(customerType), component.
 * Add new section configs in types/dsokSectionConfigs.js to extend the grid.
 */
export const sectionDefinitions = dsokSectionDefinitions;
